// Helper function to calculate cumulative fragment range for all books
export const calculateFragmentRange = async (bookName, level, currentChunk, bookFolder) => {
  let currentChunkNumber = parseInt(currentChunk.replace('chunk', ''), 10);
  if (Number.isNaN(currentChunkNumber)) {
    currentChunkNumber = 0;
  }
  
  let cumulativeCount = 0;
  let currentChunkFragments = 0;

  // Load all previous chunks to calculate cumulative count
  for (let chunkNum = 0; chunkNum <= currentChunkNumber; chunkNum++) {
    const chunkName = `chunk${chunkNum.toString().padStart(2, '0')}`;
    let chunkFragmentCount = 0;

    // Load single chunk file
    try {
      const filePath = `/content/books/${bookFolder}/adaptedContent/${level}/${chunkName}.json`;
      const response = await fetch(filePath);
      
      if (response.ok) {
        const data = await response.json();
        if (Array.isArray(data.fragments)) {
          chunkFragmentCount = data.fragments.length;
        } else if (Array.isArray(data.stanzas)) {
          chunkFragmentCount = data.stanzas.length;
        } else if (data.stanzas && typeof data.stanzas === 'object') {
          chunkFragmentCount = Object.keys(data.stanzas).length;
        } else {
          chunkFragmentCount = 0;
        }
      }
    } catch (error) {
      // Chunk doesn't exist, continue
    }
    
    if (chunkNum === currentChunkNumber) {
      currentChunkFragments = chunkFragmentCount;
    } else {
      cumulativeCount += chunkFragmentCount;
    }
  }

  const result = {
    start: cumulativeCount + 1,
    end: cumulativeCount + currentChunkFragments
  };

  return result;
};
